<template>
  <div id="components-layout-demo-basic">
    <a-layout>
      <!--   头部   -->
      <a-layout-header style="border-bottom:1px solid #eeeeee;margin-top:10px;">
        <div class="container clearfix">
          <!--   Logo   -->
          <router-link tag="a" to="/">
            <div class="logo" style="display: inline-block;height:55px;width:200px;float:left;padding-top:3px;">
              <img src="@/assets/Icons/server.svg" alt="logo" style="width:38px;height:38px;vertical-align:top;">
              <span style="">Diggo Server</span>
            </div>
          </router-link>
          <div style="width:40px;height:40px;float: right;border-radius: 50%;cursor: pointer">
            <img :src="avatar" alt="" style="width:100%;height:100%;border-radius: 50%;margin-bottom:26px;">
          </div>
        </div>
      </a-layout-header>
      <!--   内容   -->
      <a-layout-content>
        <!--   信息页   -->
        <div class="container">
          <div style="width:100%;margin-top:40px;">
            <div style="width:100%;margin-bottom:24px;;display:flex;justify-content:space-between;align-items:center;">
              <div class="history-title-text">Server Status</div>
              <div>
                <a-date-picker style="width:140px;" :default-value="serviceDate" @change="onDateChange" />
                <a-tree-select
                  v-model="treeValue"
                  style="width: 400px;margin-left:24px;"
                  :tree-data="treeData"
                  tree-checkable
                  allow-clear
                  :show-checked-strategy="SHOW_PARENT"
                  search-placeholder="Please select"
                  @change="onGroupChange"
                />
              </div>
            </div>
            <a-table
              style="margin-top:10px;"
              :loading="serviceStatusLoading"
              :columns="serviceStatusColumns" 
              :data-source="allServiceStatus"  
              :pagination="false"
              :rowKey="(record) => record.id"
            >

            </a-table>
          </div>
        </div>
      </a-layout-content>
    </a-layout>
    <Bug></Bug>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/common/api.js'
import Bug from '../../components/Bug.vue'
import { TreeSelect } from 'ant-design-vue';
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

moment.suppressDeprecationWarnings = true

const serviceStatusColumns = [
  {
    title: 'Site',
    dataIndex: 'domain',
    filters:[],
    onFilter: (value, record) => {
      return record.domain.indexOf(value) === 0
    }
  },
  // {
  //   title: 'IP',
  //   dataIndex: 'ip',
  //   width:200,
  // },
  {
    title: 'Group',
    dataIndex: 'groups',
    width:120,
    filters:[],
    onFilter: (value, record) => record.groups.indexOf(value) === 0
  },
  {
    title: 'Ping Date',
    dataIndex: 'ping_date',
  },
  {
    title: 'Ping Time',
    dataIndex: 'ping_time',
  },
  {
    title: 'Ping Hour',
    dataIndex: 'ping_hour',
    width:120,
    filters:[],
    defaultFilteredValue:[moment().hour().toString()],
    onFilter: (value, record) => record.ping_hour.indexOf(value) === 0,
  },
  {
    title: 'Ping Result',
    dataIndex: 'result',
  },
]
const treeData = [
  {
    title: 'Group 3',
    value: '3',
    key: '3',
  },
  {
    title: 'Group 4',
    value: '4',
    key: '4',
  },
  {
    title: 'Group 5',
    value: '5',
    key: '5',
  },
  {
    title: 'Group 7',
    value: '7',
    key: '7',
  },
];

export default {
  name: 'Information',
  components:{
    Bug
  },
  data() {
    return {
      SHOW_PARENT,
      serviceStatusColumns,
      treeData,
      treeValue:[],
      avatar:'',
      moment,                             //  日期
      serviceStatusLoading:false,
      allServiceStatus:[],
      serviceDate:moment()                             //  今天日期
      .format('YYYY-MM-DD')
      .slice(0, 10),
    }
  },
  methods: {
    getServerStatus() {
      this.$post(api.tool.getServerStatus, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ping_date:this.serviceDate,
        groups:this.treeValue
      }).then((res) => {
        if (res.code === 200) {
          this.serviceStatusLoading = false
          this.allServiceStatus = res.list.reverse()
          let list = res.list

          //  添加筛选内容
          // 站点
          let columns0Filter = []
          list.forEach(item => {
            let index = columns0Filter.findIndex(a => a.text == item.domain)
            if (index === -1) {
              columns0Filter.push({
                text: item.domain,
                value: item.domain,
              })
            }
          })
          serviceStatusColumns[0].filters = columns0Filter
          // 组
          let columns1Filter = []
          list.forEach(item => {
            let index = columns1Filter.findIndex(a => a.text == item.groups)
            if (index === -1) {
              columns1Filter.push({
                text: item.groups,
                value: item.groups,
              })
            }
          })
          serviceStatusColumns[1].filters = columns1Filter

          // 时间
          let columns4Filter = []
          list.forEach(item => {
            let index = columns4Filter.findIndex(a => a.text == item.ping_hour)
            if (index === -1) {
              columns4Filter.push({
                text: item.ping_hour,
                value: item.ping_hour,
              })
            }
          })
          serviceStatusColumns[4].filters = columns4Filter
        }
      })
    },

    getUserInfo() {
      this.serviceStatusLoading = true
      this.$post(api.tool.getUserInfo, {
        timestamp: Date.parse(new Date()),
        token: localStorage.impr_token,
        employee_id: this.curUserId,
        ee_id: this.curUserId
      }).then((res) => {
        if (res.code === 200) {
          if(['3','4','5','7'].includes(res.list.group_id)) {
            this.treeValue.push(res.list.group_id)
          }else {
            this.treeValue.push('3')
          }
          this.getServerStatus()
        }
      })
    },

    onDateChange(date) {
      this.serviceDate = date.format('YYYY-MM-DD')
      this.getServerStatus()
    },

    onGroupChange() {
      this.getServerStatus()
    }
  },

  created() {
    if (localStorage.impr_id && localStorage.impr_token) {
      this.avatar = localStorage.impr_picture
      this.curUserId = localStorage.impr_id
      this.getUserInfo()
    } else {
      this.$router.push({ path: '/' })
    }
  },

}
</script>

<style scoped>
/* Common */
#components-layout-demo-basic .ant-layout {
  background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
  height: 55px;
  padding: 0;
  background: #fff;
  color: #000;
}
#components-layout-demo-basic .ant-layout-content {
  background: #fff;
  color: #fff;
  min-height: 1145px;
}
.container {
  /*width: 60%;*/
  width: 1198px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  color: #000;
}
.clearfix {
  content: '';
  display: block;
  clear: both;
}

/* Logo */
.logo span {
  line-height: 38px;
  margin-left: 10px;
  vertical-align: top;
  font-family: GoogleSans-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  color: #1659c4;
}

.history-title-text {
  font-family: GoogleSans-Bold;
  font-size: 28px;
  color: #222222;
}


</style>
